import _get from 'lodash/get';
import GetText from 'node-gettext';
/**
 * translate service
 * @param {Object} config [window.config]
 * @param {Object} messages
 * @returns {Object} translate helpers
 */
export default function translateService(config, messages) {
  if (messages === void 0) {
    messages = {};
  }
  return {
    /**
     * get translator instance
     * @param {Object} msgs
     * @return {Object}
     */
    getTranslator: function getTranslator(msgs) {
      if (msgs === void 0) {
        msgs = messages;
      }
      var gt = new GetText({
        debug: _get(config, 'debug.translation', false)
      });

      // Initialize getText with translation
      Object.keys(msgs).forEach(function (lang) {
        gt.addTranslations(lang, 'messages', msgs[lang]);
      });
      gt.setLocale(config.language);
      return gt;
    }
  };
}